import React, { useMemo } from "react";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";
import {Translation as T} from "@awe-web/shared/lib";
import {provisioningTypes} from "@awe-web/shared/lib";
import {getProvisioningTypeB2b, getProvisioningTypeB2c} from "../rent_contracts/store.js";
import {ScreenSectionHeading} from "./screen.js";

import "./pickup_notice.scss";

import driversLicenseIcon from "./assets/drivers-license.svg";
import identityCardIcon from "./assets/identity-card.svg";
import creditCardIcon from "./assets/credit-card.svg";

const PICKUP_NOTICE_TITLE = "FSD0000179";
const PICKUP_REQUIRED_DOCUMENTS = "FSD0000180";
const DELIVERY_NOTICE_TITLE = "ALG0000260";
const DELIVERY_REQUIRED_DOCUMENTS = "ALG0000261";
const DRIVERS_LICENSE = "FSD0000181";
const IDENTITY_CARD = "FSD0000182";
const CREDIT_CARD = "FSD0000183";

export default function PickupNotice({reservationPath}) {
  const b2bProvisioningType = useSelector((state) => getProvisioningTypeB2b(state));
  const b2cProvisioningType = useSelector((state) => getProvisioningTypeB2c(state));
  
  const provisioningType = useMemo(() => {
    return reservationPath === "B2B" ? b2bProvisioningType : b2cProvisioningType;
  }, [b2bProvisioningType, b2cProvisioningType, reservationPath]);

  const noticeTitle = {
    [provisioningTypes.PICKUP]: PICKUP_NOTICE_TITLE,
    [provisioningTypes.DELIVERY_TO_COMPANY_ADDRESS]: DELIVERY_NOTICE_TITLE,
    [provisioningTypes.DELIVERY_TO_CUSTOM_ADDRESS]: DELIVERY_NOTICE_TITLE
  }[provisioningType];

  const requiredDocumentsLabel = {
    [provisioningTypes.PICKUP]: PICKUP_REQUIRED_DOCUMENTS,
    [provisioningTypes.DELIVERY_TO_COMPANY_ADDRESS]: DELIVERY_REQUIRED_DOCUMENTS,
    [provisioningTypes.DELIVERY_TO_CUSTOM_ADDRESS]: DELIVERY_REQUIRED_DOCUMENTS
  }[provisioningType];

  return (
    <div className="pickup-notice">
      <ScreenSectionHeading>
        <T code={noticeTitle} />
      </ScreenSectionHeading>

      <div className="pickup-notice__description">
        <T code={requiredDocumentsLabel} />
      </div>

      <ul className="pickup-notice__documents">
        <li className="pickup-notice__drivers-license">
          <img src={driversLicenseIcon} alt="" />
          <T code={DRIVERS_LICENSE} />
        </li>
        <li className="pickup-notice__identity-card">
          <img src={identityCardIcon} alt="" />
          <T code={IDENTITY_CARD} />
        </li>
        {reservationPath === "B2C" && (
          <li className="pickup-notice__credit-card">
            <img src={creditCardIcon} alt="" />
            <T code={CREDIT_CARD} />
          </li>
        )}
      </ul>
    </div>
  );
}

PickupNotice.propTypes = {
  reservationPath: PropTypes.oneOf(["B2C", "B2B"]).isRequired,
};
